import { Component, OnInit } from '@angular/core';
import { TokenService } from '../service/token.service';
import { Router } from '@angular/router';
import { UtilsService } from '../service/utils.service';
import { GlobalConfig } from '../entities/global-config';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs/Subject';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  apiUrl: any = '';
  constructor(
    private servicesToken: TokenService,
    private router: Router,
    private utilsService: UtilsService,
    private config: GlobalConfig,
    private toastr: ToastsManager
  ) { }
  isAgent: Boolean = false;
  isUser: Boolean = false;
  agentId: any = '';
  admin: Boolean = false;
  agentDetail: any = '';
  ngOnInit() {
    const roles = localStorage.getItem("role");
    this.apiUrl = this.config.apiRootUrl;
    this.setPermissions(roles)
    this.getProfile();
  }
  setPermissions(roles) {
    const userId = Number(JSON.parse(localStorage.getItem("profile")).nameid);
    const data = this;
    if (roles != null) {
      const roleName = roles.split(",");
      roleName.forEach(function (value) {
        switch (value) {
          case "agents":             
            data.isAgent = true;
            break;
          case "admins":
            data.admin = true;
            break;

          case "user":
            data.isUser = true;
            break;
          default:
            break;
        }

      });
    }
  }

  signout() {
    this.servicesToken.logout();
  }

  getProfile() {
    this.agentDetail = this.servicesToken.getProfile();
    console.log(this.agentDetail.logo);
  }
}



// WEBPACK FOOTER //
// D:/Projects/Web/Dubai/code/kapil/DubairentV3/cpapi/CPDubairentApp/CPDubairentApp/src/app/dashboard/dashboard.component.ts